<template>
    <div>
        <NavPublic />
        <div v-if="accessClinic">
            <v-container class="mt-5">
                <v-alert
                    icon="mdi-file-pdf"
                    prominent
                    border="left"
                    text
                    type="info"
                    dense
                    >
                    En esta sección podrá ver y descargar los resultados de las ordenes de laboratório
                </v-alert>
                <v-col cols="12">
                    <v-row>
                        <v-col
                            cols="12"
                            sm="4"
                            class="py-0"
                        >
                            <v-menu>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateRangeText"
                                        label="Fechas"
                                        persistent-hint
                                        readonly
                                        append-icon="mdi-calendar-multiple"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    range
                                    v-model="dates"
                                    no-title
                                    @input="menu = false"
                                    @change="searchDataTable"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                            <v-col
                            cols="12"
                            sm="4"
                            class="py-0"
                        >
                            <v-select
                            label="Estado"
                                v-model=stateListOrder
                                :items= statesListOrder
                                item-value="status_id"
                                item-text="name"
                                prepend-icon="mdi-clock-alert"
                                @change="searchDataTable"
                            >
                            </v-select>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            class="py-0"
                        >
                            <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Buscar"
                                single-line
                                hide-details
                                @click:append=getDataComponent
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-data-table
                    :headers=headers
                    :items=dataTable
                    :options.sync=options
                    :server-items-length=totalItems
                    :loading=loadingTable
                    :search=search
                    class="elevation-3"
                    v-if=accessViewOrders
                >
                    
                    <!-- <template v-slot:top>
                        <v-toolbar flat color="white" class=pt-md-5>
                            <v-row>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-menu>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="dateRangeText"
                                                label="Fechas"
                                                persistent-hint
                                                readonly
                                                append-icon="mdi-calendar-multiple"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            range
                                            v-model="dates"
                                            no-title
                                            @input="menu = false"
                                            @change="searchDataTable"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                 <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-select
                                    label="Estado"
                                        v-model=stateListOrder
                                        :items= statesListOrder
                                        item-value="status_id"
                                        item-text="name"
                                        prepend-icon="mdi-clock-alert"
                                        @change="searchDataTable"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col
                                    cols="12"
                                    sm="4"
                                >
                                    <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Buscar"
                                        single-line
                                        hide-details
                                        @click:append=getDataComponent
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-toolbar>
                    </template> -->
                    <template v-slot:item.action="{ item }">
                        <v-icon @click="detailOrder(item)">mdi-file-document</v-icon>
                    </template>
                    
                </v-data-table>
                <v-col 
                    v-else
                    cols="12"
                >
                    <v-alert
                        color="red"
                        border="left"
                        elevation="2"
                        colored-border
                        icon="mdi-cancel"
                    >
                            No tiene permisos para listar las ordenes
                    </v-alert>
                </v-col>
                <v-dialog 
                    v-model="dialogOrder" 
                    max-width="1000px"
                    persistent
                >
                    <v-card>
                        <v-card-title>
                        <span class="headline">Detalle de la orden </span>
                        </v-card-title>

                        <v-card-text class="px-0">
                            <v-container fluid>
                                <v-row>
                                    <v-col 
                                        cols="12"
                                        md="4"
                                        style="border-right:1px solid silver"
                                    >
                                        <v-list class="py-0">
                                            <v-list-item
                                                
                                            >
                                                <v-list-item-avatar  >
                                                <v-icon color="primary">mdi-36px mdi-checkbox-multiple-marked-outline</v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                <v-list-item-title>Orden</v-list-item-title>
                                                <v-list-item-subtitle>{{dataDetailOrder.order}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-list class="py-0">
                                            <v-list-item>
                                                <v-list-item-avatar  >
                                                <v-icon color="primary">mdi-36px mdi-account-circle</v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                <v-list-item-title>Paciente</v-list-item-title>
                                                <v-list-item-subtitle>{{dataDetailOrder.patient}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-list class="py-0">
                                            <v-list-item
                                                
                                            >
                                                <v-list-item-avatar >
                                                <v-icon color="primary">mdi-36px mdi-account-star</v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                <v-list-item-title>Médico</v-list-item-title>
                                                <v-list-item-subtitle>{{dataDetailOrder.doctor}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-list class="py-0">
                                            <v-list-item >
                                                <v-list-item-avatar >
                                                <v-icon color="primary">mdi-36px mdi-calendar</v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                <v-list-item-title>Fecha</v-list-item-title>
                                                <v-list-item-subtitle>{{dataDetailOrder.date}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-list class="py-0">
                                            <v-list-item >
                                                <v-list-item-avatar >
                                                <v-icon color="primary">mdi-36px mdi-check-circle-outline</v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>
                                                <v-list-item-title>Estado</v-list-item-title>
                                                <v-list-item-subtitle>{{state}}</v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                    <v-col 
                                        cols="12"
                                        md="8"
                                    >
                                        <v-simple-table 
                                            dense 
                                        >
                                            <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">Examenes</th>
                                                    <th class="text-center">Estado</th>
                                                    <th class="text-center">Resultados</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(detail, x) in dataDetailOrder.details" :key="x">
                                                
                                                    <td style="boder:1px solid">{{detail.desc_item}}</td>
                                                    <td style="boder:1px solid" class="text-center">{{detail.desc_status}}</td>
                                                    <td style="border: 1px solid silver;"
                                                        class="text-center" 
                                                        v-if="detail.print" 
                                                        :rowspan="detail.rowspan"
                                                    >
                                                        <v-btn 
                                                            small 
                                                            color="primary" 
                                                            @click="viewPdf(detail)"
                                                            v-if="detail.archive && dowloadFiles & detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null.pdf'"
                                                        >
                                                            <v-icon>mdi-file-pdf</v-icon> Descargar
                                                        </v-btn>
                                                        <!-- <v-btn 
                                                            link small 
                                                            color="primary" 
                                                            target="_blank" 
                                                            :href=detail.archive
                                                            v-if="detail.archive && dowloadFiles & detail.archive.split('/')[detail.archive.split('/').length-1].toString() != 'null'"
                                                        >
                                                            <v-icon>mdi-file-pdf</v-icon> Descargar
                                                        </v-btn> -->
                                                        <span v-else>{{!dowloadFiles ? 'No puede descargar documentos' : 'Sin documento'}}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </template>
                                        </v-simple-table>   
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-col cols="12" class="text-center">
                            <v-btn color="secondary" @click=closeDialogOrder>
                                <v-icon>mdi-cancel</v-icon> Cerrar
                            </v-btn>
                        </v-col>
                    </v-card>
                </v-dialog>
           </v-container>
        </div>
        <div v-else>No tiene acceso a esta vista</div>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import NavPublic from '../../base/NavPublicComponent'

    export default {
        name:'ListOrdersComponent',
        components:{
            NavPublic
        },
        data: () => ({
            dates: [],
            menu: true,
            dialogOrder:false,
            totalItems: 0,
            stateListOrder:'OLST_COMPLETADA',
            state:'',
            rowIncrement:0,
            dataDetailOrder:{
                order:'',
                patient:'',
                doctor:'',
                date:'',
                details:[]
            },
            dataDefaultDetailOrder:{
                order:'',
                patient:'',
                doctor:'',
                date:'',
                details:[]
            },
            dataTable: [],
            search:'',
            options: {},
            headers: [
                { text: 'Nº Orden', value: 'olab_id' },
                { text: 'Paciente', value: 'paciente' },
                { text: 'Fecha', value: 'olab_fecha' },
                { text: 'Médico', value: 'doctor' },
                { text: 'Estado', value: 'status' },
                { text: 'Acción', value: 'action' },
            ],
        }),
        watch: {
            
            options: {
                handler () {
                    this.getDataComponent()
                }, 
                deep: true,
            },
        },
        computed:{
                ...mapState([
                    'idActionsRol',
                    'loadingTable',
                    'user',
                    'pathFileOder',
                    'statesListOrder',
                    'pathFileOrder',
                    'urlApi'
                ]),

                dateRangeText () {
                    return this.dates.join(' ~ ')
                },

                accessClinic (){
                    return typeof this.idActionsRol.find(e => e === 'ACCESO_WEB_CLINICA') != "undefined";
                },

                accessViewOrders(){
                    return typeof this.idActionsRol.find(e => e === 'LISTA_ORDENES') != "undefined";
                },

                dowloadFiles(){
                    return typeof this.idActionsRol.find(e => e === 'DESCARGA_ORDENES') != "undefined";
                }
            },
        methods: {

            ...mapMutations(['setLoadingTable','setUrl']),

            ...mapActions(['requestApi']),

            searchDataTable(){
                this.getDataComponent()
            },

            getDataComponent(){
                this.setLoadingTable(true)

                this.setUrl('ordenes-laboratorio')
                const { sortBy, sortDesc, page, itemsPerPage } = this.options
                this.requestApi({
                    method:'GET',
                    data:{
                        page:page,
                        itemsPerPage: itemsPerPage,
                        search:this.search,
                        dates: this.dateRangeText,
                        party_id : this.user.party_id,
                        party_type_id : this.user.party_type,
                        stateOrder : this.stateListOrder
                    }
                })
                .then(res=>{
                    console.log(res)
                    let items = res.data._embedded.ordenes_laboratorio.filter(e => e.status_id_order != 'OLST_CANCELADA')
                    this.totalItems= res.data.total_items
                    this.dataTable= items
                    const total = items.length

                    if (sortBy.length === 1 && sortDesc.length === 1) {
                        items = items.sort((a, b) => {
                        const sortA = a[sortBy[0]]
                        const sortB = b[sortBy[0]]

                        if (sortDesc[0]) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                        })
                    }

                    if (itemsPerPage > 0) {
                        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
                    }
                    this.setLoadingTable(false)

                })

            },

            detailOrder(item){
                this.setLoadingTable(true)
                this.setUrl('ordenes-laboratorio/'+item.olab_id)
                this.dataDetailOrder.order= "#"+item.olab_id
                this.dataDetailOrder.patient= item.paciente
                this.dataDetailOrder.doctor= item.doctor
                this.dataDetailOrder.date= item.olab_fecha
                this.requestApi({
                    method:'GET',
                    data:{}
                }).then(res=>{
                    let proveedor_id = ''
                    let x=0
                    let rowspan = ''
                    let archive =''
                    this.dataDetailOrder.details = res.data.items.map((obj)=>{
                        let print = proveedor_id != obj.proveedor_id
                        if(print){
                            rowspan = typeof res.data.rowspan[x] != 'undefined' ? res.data.rowspan[x].rowspan  : ''
                            archive = typeof res.data.rowspan[x] != 'undefined' ? this.pathFileOrder+res.data.rowspan[x].ruta_documento+'.pdf'  : ''
                            x++
                        }else{
                            archive=false
                        }
                        obj.print = print
                        obj.rowspan = rowspan
                        obj.archive = archive
                        proveedor_id = obj.proveedor_id
                        return obj
                    })
                    this.dialogOrder=true
                    const match = e => e.status_id === "OLIT_SOLICITADO"
                    let stateOrder = res.data.items.find(match)
                    typeof stateOrder != 'undefined'
                        ? this.state= "Solicitado" 
                        : this.state= "Completado" 

                    this.setLoadingTable(false)
                })

            },
            
            closeDialogOrder(){
                this.dialogOrder=false
                Object.assign(this.dataDetailOrder,this.dataDefaultDetailOrder)
            },
        
            viewPdf(detail){
                window.open(this.urlApi+'file.php?file=pdf/'+detail.archive.split("/")[detail.archive.split("/").length-1])
                this.setUrl('ordenes-laboratorio/1')
                this.requestApi({
                    method: 'PUT',
                    data:{
                        preview : 'irewniubn',
                        file : detail.archive.split("/")[detail.archive.split("/").length-1],
                        userLoginId : this.user.user_ligin_id,
                        system: 'laboratorio',
                        dataBase: 'obinnoclinica',
                        comment: this.user.user_ligin_id+' se ha descargado el archivo '+detail.archive.split("/")[detail.archive.split("/").length-1]
                    }
                }).then(res=>{
                    
                })
            }
        },
        created(){
            let d = new Date()
            let month = d.setMonth(d.getMonth()-1)
            let dd = new Date(month).toISOString().substr(0, 10)
            this.dates = [
                dd,
                new Date().toISOString().substr(0, 10)
            ]
        }
      
    }
</script>

<style scope>
    @media(max-width: 600px){
        #app > div > div > div:nth-child(2) > div > div.v-data-table.elevation-3.theme--light > div.v-data-table__wrapper > table > thead{
            display: none;
        }
        .v-text-field{
            padding-top: 0px!important;
            margin-top: 0px!important;
        }
        .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:last-child, .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>th:not(.v-data-table__mobile-row), .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
            border-bottom: thin solid rgb(0 0 0)!important;
        }
    }
</style>